import { render, staticRenderFns } from "./areaData.vue?vue&type=template&id=46920b48&scoped=true&"
import script from "./areaData.vue?vue&type=script&lang=js&"
export * from "./areaData.vue?vue&type=script&lang=js&"
import style0 from "./areaData.vue?vue&type=style&index=0&id=46920b48&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46920b48",
  null
  
)

export default component.exports